﻿import type { EPIRequest, Incident, Denunciation } from '@/types';

export const mockEPIRequests: EPIRequest[] = [
  {
    id: 'epi-001',
    userId: 'colab-001',
    userName: 'JoÃ£o Silva',
    setor: 'ProduÃ§Ã£o',
    motivo: 'O anterior encontra-se danificado',
    urgencia: 'Imediato - Estou sem',
    observacao: 'As luvas rasgaram durante o trabalho de ontem.',
    itens: [
      { tipo: 'Luvas', q01: 1, q02: 0, qCaixa: 0 },
      { tipo: 'Botina com cadarÃ§o', q01: 1, q02: 0, qCaixa: 0 },
    ],
    status: 'Pendente',
    createdAt: '2024-07-01T10:30:00Z',
  },
  {
    id: 'epi-002',
    userId: 'colab-002',
    userName: 'Maria Santos',
    setor: 'LaboratÃ³rio',
    motivo: 'O anterior encontra-se danificado',
    urgencia: 'Médio - Ainda consigo usar o meu',
    observacao: '',
    itens: [
      { tipo: 'MÃ¡scara', q01: 2, q02: 0, qCaixa: 0 },
      { tipo: 'Ã“culos', q01: 1, q02: 0, qCaixa: 0 },
      { tipo: 'Protetor Auditivo', q01: 0, q02: 0, qCaixa: 1 },
    ],
    status: 'Aprovado',
    createdAt: '2024-07-02T08:15:00Z',
  },
  {
    id: 'epi-003',
    userId: 'colab-001',
    userName: 'JoÃ£o Silva',
    setor: 'ProduÃ§Ã£o',
    motivo: 'Perdi o anterior',
    urgencia: 'Imediato - Estou sem',
    observacao: 'Perdi o capacete durante a mudanÃ§a de galpÃ£o.',
    itens: [
      { tipo: 'Capacete', q01: 1, q02: 0, qCaixa: 0 },
    ],
    status: 'Negado',
    createdAt: '2024-07-03T14:20:00Z',
  },
  {
    id: 'epi-004',
    userId: 'colab-002',
    userName: 'Maria Santos',
    setor: 'LaboratÃ³rio',
    motivo: 'Mudei de setor',
    urgencia: 'Aguardo - Apenas reposição periódica',
    observacao: 'Mudei do setor de ProduÃ§Ã£o para o LaboratÃ³rio.',
    itens: [
      { tipo: 'Avental', q01: 1, q02: 0, qCaixa: 0 },
      { tipo: 'Luvas', q01: 0, q02: 0, qCaixa: 2 },
      { tipo: 'Protetor Auditivo', q01: 1, q02: 0, qCaixa: 0 },
    ],
    status: 'Aprovado',
    createdAt: '2024-07-04T09:00:00Z',
  },
  {
    id: 'epi-005',
    userId: 'colab-001',
    userName: 'JoÃ£o Silva',
    setor: 'ProduÃ§Ã£o',
    motivo: 'O anterior encontra-se danificado',
    urgencia: 'Médio - Ainda consigo usar o meu',
    observacao: '',
    itens: [
      { tipo: 'Botina sem cadarÃ§o', q01: 1, q02: 0, qCaixa: 0 },
    ],
    status: 'Pendente',
    createdAt: '2024-07-05T11:45:00Z',
  },
  {
    id: 'epi-006',
    userId: 'colab-002',
    userName: 'Maria Santos',
    setor: 'LaboratÃ³rio',
    motivo: 'Esqueci o meu em outro lugar',
    urgencia: 'Imediato - Estou sem',
    observacao: 'Esqueci os Ã³culos na ETA durante a visita tÃ©cnica.',
    itens: [
      { tipo: 'Ã“culos', q01: 1, q02: 0, qCaixa: 0 },
    ],
    status: 'Aprovado',
    createdAt: '2024-06-28T15:30:00Z',
  },
  {
    id: 'epi-007',
    userId: 'colab-001',
    userName: 'JoÃ£o Silva',
    setor: 'ProduÃ§Ã£o',
    motivo: 'Outro',
    urgencia: 'Aguardo - Apenas reposição periódica',
    observacao: 'Troca programada semestral dos EPIs.',
    itens: [
      { tipo: 'Luvas', q01: 0, q02: 0, qCaixa: 4 },
      { tipo: 'MÃ¡scara', q01: 0, q02: 0, qCaixa: 3 },
    ],
    status: 'Pendente',
    createdAt: '2024-06-20T10:00:00Z',
  },
  {
    id: 'epi-008',
    userId: 'colab-002',
    userName: 'Maria Santos',
    setor: 'LaboratÃ³rio',
    motivo: 'O anterior encontra-se danificado',
    urgencia: 'Médio - Ainda consigo usar o meu',
    observacao: 'O avental estÃ¡ com rasgos na parte frontal.',
    itens: [
      { tipo: 'Avental', q01: 1, q02: 0, qCaixa: 0 },
    ],
    status: 'Negado',
    createdAt: '2024-06-15T13:10:00Z',
  },
];

export const mockIncidents: Incident[] = [
  {
    id: 'inc-001',
    userId: 'colab-002',
    userName: 'Maria Santos',
    setor: 'LaboratÃ³rio',
    noSetor: 'Sim',
    tipoIncidente: 'TIVE UMA LESÃƒO NAS MÃƒOS',
    descricao: 'Ao manipular um vidro de reagente, ocorreu um corte leve na palma da mÃ£o esquerda. Foi feito curativo no local.',
    fotoUrl: '',
    declaracaoVerdade: true,
    status: 'Em análise',
    createdAt: '2024-07-03T14:15:00Z',
  },
  {
    id: 'inc-002',
    userId: 'colab-001',
    userName: 'JoÃ£o Silva',
    setor: 'ProduÃ§Ã£o',
    noSetor: 'Sim',
    tipoIncidente: 'DERRAME PRODUTO - PEQ QUANT',
    descricao: 'Pequeno derramamento de Ã³leo lubrificante prÃ³ximo Ã  esteira 3. Contido imediatamente com kit de contenÃ§Ã£o.',
    fotoUrl: '',
    declaracaoVerdade: true,
    status: 'Em análise',
    createdAt: '2024-07-01T09:30:00Z',
  },
  {
    id: 'inc-003',
    userId: 'colab-002',
    userName: 'Maria Santos',
    setor: 'LaboratÃ³rio',
    noSetor: 'NÃ£o',
    tipoIncidente: 'QUEIMADURAS',
    descricao: 'Queimadura leve no antebraÃ§o ao encostar em superfÃ­cie quente da autoclave. Aplicado pomada e curativo.',
    fotoUrl: '',
    declaracaoVerdade: true,
    status: 'Em análise',
    createdAt: '2024-06-25T16:00:00Z',
  },
  {
    id: 'inc-004',
    userId: 'colab-001',
    userName: 'JoÃ£o Silva',
    setor: 'ProduÃ§Ã£o',
    noSetor: 'Sim',
    tipoIncidente: 'TIVE UM ARRANHÃƒO',
    descricao: 'ArranhÃ£o superficial no braÃ§o direito ao manusear chapas metÃ¡licas sem proteÃ§Ã£o adequada.',
    fotoUrl: '',
    declaracaoVerdade: true,
    status: 'Em análise',
    createdAt: '2024-06-18T11:20:00Z',
  },
];

export const mockDenunciations: Denunciation[] = [
  {
    id: 'den-001',
    userId: 'colab-001',
    identificar: true,
    nomeIdentificado: 'JoÃ£o Silva',
    setor: 'ProduÃ§Ã£o',
    assedioExplicado: true,
    tipoAssedio: 'Verbal descontextualizado',
    autoresNome: 'Supervisor do turno da noite',
    anexoUrl: '',
    detalhes: 'Durante a troca de turno, o supervisor fez comentÃ¡rios inadequados sobre minha performance em frente a outros colegas.',
    nivelAssedio: 6,
    ultimaOcorrencia: '2024-07-02',
    acessoRetorno: 'joao.silva@portal.com',
    observacoes: 'Solicito sigilo sobre a denÃºncia.',
    status: 'Em análise',
    createdAt: '2024-07-04T09:00:00Z',
  },
  {
    id: 'den-002',
    userId: undefined,
    identificar: false,
    setor: 'Administrativo',
    assedioExplicado: false,
    tipoAssedio: 'Outro',
    autoresNome: 'NÃ£o identificado',
    anexoUrl: '',
    detalhes: 'SituaÃ§Ã£o de assÃ©dio moral recorrente na Ã¡rea administrativa. Comportamento abusivo por parte da gestÃ£o intermediÃ¡ria.',
    nivelAssedio: 8,
    ultimaOcorrencia: '2024-07-01',
    acessoRetorno: 'anonimo@temp.com',
    observacoes: '',
    status: 'Em análise',
    createdAt: '2024-07-05T16:30:00Z',
  },
  {
    id: 'den-003',
    userId: 'colab-002',
    identificar: true,
    nomeIdentificado: 'Maria Santos',
    setor: 'LaboratÃ³rio',
    assedioExplicado: true,
    tipoAssedio: 'HostilizaÃ§Ã£o',
    autoresNome: 'Coordenador do laboratÃ³rio',
    anexoUrl: '',
    detalhes: 'ExclusÃ£o sistemÃ¡tica das reuniÃµes de equipe e atribuiÃ§Ã£o de tarefas abaixo da qualificaÃ§Ã£o tÃ©cnica.',
    nivelAssedio: 7,
    ultimaOcorrencia: '2024-06-28',
    acessoRetorno: 'maria.santos@portal.com',
    observacoes: 'JÃ¡ conversei com o RH sobre a situaÃ§Ã£o.',
    status: 'Em análise',
    createdAt: '2024-06-30T10:45:00Z',
  },
];

